module.exports = __webpack_public_path__ + "static/media/mainD.ac24d00e.png";